import { Component, OnInit, Input } from '@angular/core';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-uid-column',
    templateUrl: './uid-column.component.html',
    styleUrls: ['./uid-column.component.scss'],
    standalone: false
})
export class UidColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor() {}

  ngOnInit(): void {}

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }
}
